<template>
  <!-- 查询条件区域 -->
  <el-form class="search-form" :model="searchForm" label-width="80px" size="small">
    <el-row type="flex" class="search-row">
      <el-col :span="4">
        <el-form-item label=" " label-width="20px">
          <el-input v-model="searchForm.searchValue" placeholder="搜索计划编号/名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="任务类型">
          <el-select v-model="searchForm.businessType" placeholder="请选择任务类型">
            <el-option v-for="item in $store.getters.commonDict['businessType']" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="任务状态">
          <el-select v-model="searchForm.planState" placeholder="请选择任务状态">
            <el-option label="未开始" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已完成" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item label="查询时间">
          <el-date-picker style="width: 100%;" :clearable="false" v-model="searchForm.dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="5" class="search-actions">
        <el-form-item label-width="0">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-col>
    </el-row>

  </el-form>
</template>

<script>
import { getMonthStartTime, getTodayEndTime } from "@/util/date.js";

export default {
  inject: ["_parentThis"],
  data () {
    return {
      searchForm: {},
    };
  },
  watch: {
    'searchForm.dateRange' (nVal) {
      if (nVal && nVal.length) {
        this.$set(this.searchForm, 'startTime', nVal[0])
        this.$set(this.searchForm, 'endTime', nVal[1])
      } else {
        this.$set(this.searchForm, 'startTime', '')
        this.$set(this.searchForm, 'endTime', '')
      }
    },
  },
  created () {
    this.setDate()
  },
  methods: {
    setDate () {
      this.$set(this.searchForm, 'dateRange', [getMonthStartTime(), getTodayEndTime()])
    },
    handleSearch () {
      // 处理查询逻辑
      console.log('查询条件：', this.searchForm);
      this.$emit('handleSearch')
    },
    handleReset () {
      // 重置查询条件
      this.searchForm = {
        keyword: '',
        taskType: '',
        taskStatus: '',
        startTime: '',
        endTime: ''
      };
      this.$set(this.searchForm, 'dateRange', [getMonthStartTime(), getTodayEndTime()])
      this.$emit('handleSearch')
    },
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
.search-form {
  width: 100%;
  min-width: 0;
  background: #f0f7ff;
  border: none;
  border-radius: 0;
  padding: 12px 16px 10px;
  margin-bottom: 0;
  box-sizing: border-box;

  .search-row {
    align-items: center;
    width: 100%;
  }

  .el-col {
    padding-right: 12px;
    box-sizing: border-box;

    &:last-child {
      padding-right: 0;
    }
  }

  .el-form-item {
    margin-bottom: 0;

    &__label {
      color: #1f2937;
      font-size: 13px;
      font-weight: 400;
    }
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-date-editor {
    width: 100%;
    background-color: #fff;
  }

  ::v-deep .el-range-separator {
    color: #606266;
  }

  .search-actions {
    display: flex;
    justify-content: flex-end;

    ::v-deep .el-form-item__content {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      line-height: 32px;
    }

    .el-button + .el-button {
      margin-left: 10px;
    }
  }
}
</style>
